// src/api/systemAnalyzerApi/@tanstack/initializer.ts
import { useAuthStore } from '@/stores/auth'
import { client } from '../client.gen'

// Override hardcoded URLs with environment variables
// Vite automatically loads .env files and makes VITE_* variables available
const apiUrl =
  import.meta.env.VITE_SYSTEM_ANALYZER_API_URL || (typeof window !== 'undefined' && window.ENV?.SYSTEM_ANALYZER_API_URL)
if (apiUrl) {
  client.setConfig({
    baseUrl: apiUrl,
  })
}

client.interceptors.request.use(config => {
  const authHeaders = useAuthStore.getState().getAuthHeaders()

  if (Object.keys(authHeaders).length > 0) {
    Object.entries(authHeaders).forEach(([key, value]) => {
      config.headers.set(key, value)
    })
  }

  return config
})

// Export the configured client
export { client }
